/* istanbul ignore file */
import { useState } from 'react'
import { ComposableMap, Geographies, Geography, ZoomableGroup } from 'react-simple-maps'

import { HandTapIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import HeatMapLegend from './HeatMapLegend/HeatMapLegend'
import Tooltip from './Tooltip/Tooltip'
import * as Styles from './styles'

const geoUrl = 'https://assets-reveni-spaces.fra1.cdn.digitaloceanspaces.com/public/world-topo.json'

const WorldMap = ({ onSelectCountry, selectedCountry, heatMapMetrics, quintiles, orderBy, currency }) => {
  const theme = useTheme()
  const [tooltip, setTooltip] = useState({ name: '', x: 0, y: 0, visible: false })
  const [showHand, setShowHand] = useState(true)

  const handleMouseEnter = (geo, evt) => {
    setTooltip({
      name: geo.properties.name,
      x: evt.clientX,
      y: evt.clientY,
      visible: true,
      value: heatMapMetrics?.find(c => c.country_code === geo.properties.countryCode)?.value || 0,
    })
  }

  const handleMouseLeave = () => {
    setTooltip({ ...tooltip, visible: false })
  }

  const isSelectedCountry = countryCode => {
    if (selectedCountry) {
      return countryCode === selectedCountry
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      {showHand && (
        <Styles.HandContainer
          initial={{ x: 0, opacity: 1 }}
          animate={{ x: [-50, 50, -25, 0], opacity: [1, 1, 1, 1, 0] }}
          transition={{
            x: { times: [0, 0.5, 0.8, 1], duration: 2, ease: 'easeInOut' },
            opacity: { delay: 2, duration: 0.5 },
          }}
          onAnimationComplete={() => setShowHand(false)}
        >
          <HandTapIcon size={100} color={theme.colors.text.subtle} />
        </Styles.HandContainer>
      )}
      <ComposableMap>
        <ZoomableGroup center={[0, 0]} zoom={1}>
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map(geo => (
                <Geography
                  onClick={() => onSelectCountry(geo.properties.countryCode)}
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                    default: {
                      fill: heatMapMetrics?.find(c => c.country_code === geo.properties.countryCode)?.color || '#ccc',
                      outline: 'none',
                      stroke: isSelectedCountry(geo.properties.countryCode) ? theme.colors.danger.onSurface : 'none',
                      strokeWidth: 1,
                      transition: 'fill 0.3s ease',
                    },
                    hover: {
                      fill: heatMapMetrics?.find(c => c.country_code === geo.properties.countryCode)?.color || '#ccc',
                      stroke: theme.colors.danger.onSurface,
                      strokeWidth: 1,
                      outline: 'none',
                      cursor: 'pointer',
                      borderColor: 'red',
                    },
                  }}
                  onMouseEnter={evt => handleMouseEnter(geo, evt)}
                  onMouseLeave={handleMouseLeave}
                />
              ))
            }
          </Geographies>
        </ZoomableGroup>
      </ComposableMap>
      <HeatMapLegend quintiles={quintiles} orderBy={orderBy} currency={currency} />
      {tooltip.visible && <Tooltip tooltip={tooltip} orderBy={orderBy} currency={currency} />}
    </div>
  )
}

export default WorldMap
